import axios from 'axios'
import library from '../../../utils/Library'

export const getAllApplicationAppModule = async (appCode = "ME") => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_authz') +
    `/getAllApplicationAppModuleEAuthz?appCode=${appCode}`

  return await axios({
    url: URL,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
